// extracted by mini-css-extract-plugin
module.exports = {"limitedWidth":"Posts_limitedWidth__eHTaq","center":"Posts_center__1GZl6"};